<template>
  <div v-if="SecretBooba">
    <div v-for="type in vorktype" :key="type" class="d-flex justify-space-between align-center">
      <p class="font-weight-bold" style="width: 300px">{{ type }}</p>
      <template v-for="element in report_data.filter(el => el['ТипРаботПРЕДСТАВЛЕНИЕ'] === type)" :key="element">
        <v-text-field v-model="element['КоличествоЧеловекоЧасов']">
          {{ element['Вид'] }}:
        </v-text-field>
      </template>
    </div>
    <v-btn v-on:click="resave_data()" flat block>ИЗМЕНИТЬ</v-btn>
  </div>

  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {SecretBooba} from "@/store/SecretBooba";

export default {
  name: "3fd7613e-0de0-11eb-8114-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      vorktype: [],
      plan: [],
      actual: []
    }
  },
  computed: {
    SecretBooba: {
      get() {
        return SecretBooba().get()
      },
      set(value) {
        return SecretBooba().set(value)
      }
    },
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    resave_data: function () {
      this.report_data = this.report_data.map(el => {
        return parseInt(el['КоличествоЧеловекоЧасов'])
      })
      this.update_chart()
    },
    make_chart: function () {
      if (this.canvas) {
        this.update_data()
        this.graph = new Chart(this.canvas, {
          plugins: [ ChartDataLabels ],
          type: 'bar',
          data: {
            labels: this.vorktype,
            datasets: [
              {
                label: 'План',
                data: this.plan,
                maxBarThickness: 800
              },
              {
                label: 'Факт',
                data: this.actual,
                maxBarThickness: 800
              }
            ]
          },
          options: {
            plugins: {
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'end'
              }
            },
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        })
      }
    },
    update_data: function () {
      this.vorktype = []
      this.plan = []
      this.actual = []
      for (let i =0; i < this.chart.report_data.length; i++) {
        if (!this.vorktype.includes(this.chart.report_data[i]["ТипРаботПРЕДСТАВЛЕНИЕ"]) && this.chart.report_data[i]["ТипРаботПРЕДСТАВЛЕНИЕ"] !== "Итого") {
          this.vorktype.push(this.chart.report_data[i]["ТипРаботПРЕДСТАВЛЕНИЕ"])
        }
      }
      this.vorktype.push('Итого')
      for (let i = 0; i < this.chart.report_data.length; i++) {
        if (this.chart.report_data[i]["Вид"] === 'План') {
          this.plan[this.vorktype.indexOf(this.chart.report_data[i]["ТипРаботПРЕДСТАВЛЕНИЕ"])] = this.chart.report_data[i]["КоличествоЧеловекоЧасов"]
        }
        if (this.chart.report_data[i]["Вид"] === 'Факт') {
          this.actual[this.vorktype.indexOf(this.chart.report_data[i]["ТипРаботПРЕДСТАВЛЕНИЕ"])] = this.chart.report_data[i]["КоличествоЧеловекоЧасов"]
        }
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.make_chart()
    }
  },
}
</script>